/* eslint-disable*/
/*
    验证数字：^[0-9]*$
    验证n位的数字：^\d{n}$
    验证至少n位数字：^\d{n,}$
    验证m-n位的数字：^\d{m,n}$
    验证零和非零开头的数字：^(0|[1-9][0-9]*)$
    验证有两位小数的正实数：^[0-9]+(.[0-9]{2})?$
    验证有1-3位小数的正实数：^[0-9]+(.[0-9]{1,3})?$
    验证非零的正整数：^\+?[1-9][0-9]*$
    验证非零的负整数：^\-[1-9][0-9]*$
    验证非负整数（正整数 + 0）  ^\d+$
    验证非正整数（负整数 + 0）  ^((-\d+)|(0+))$
    验证长度为3的字符：^.{3}$
    验证由26个英文字母组成的字符串：^[A-Za-z]+$
    验证由26个大写英文字母组成的字符串：^[A-Z]+$
    验证由26个小写英文字母组成的字符串：^[a-z]+$
    验证由数字和26个英文字母组成的字符串：^[A-Za-z0-9]+$
    验证由数字、26个英文字母或者下划线组成的字符串：^\w+$
    验证用户密码:^[a-zA-Z]\w{5,17}$ 正确格式为：以字母开头，长度在6-18之间，只能包含字符、数字和下划线。
    验证是否含有 ^%&',;=?$\" 等字符：[^%&',;=?$\x22]+
    验证汉字：^[\u4e00-\u9fa5],{0,}$
    验证Email地址：^\w+[-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$
    验证InternetURL：^http://([\w-]+\.)+[\w-]+(/[\w-./?%&=]*)?$ ；^[a-zA-z]+://(w+(-w+)*)(.(w+(-w+)*))*(?S*)?$
    验证电话号码：^(\(\d{3,4}\)|\d{3,4}-)?\d{7,8}$：--正确格式为：XXXX-XXXXXXX，XXXX-XXXXXXXX，XXX-XXXXXXX，XXX-XXXXXXXX，XXXXXXX，XXXXXXXX。
    验证身份证号（15位或18位数字）：^\d{15}|\d{}18$
    验证一年的12个月：^(0?[1-9]|1[0-2])$ 正确格式为：“01”-“09”和“1”“12”
    验证一个月的31天：^((0?[1-9])|((1|2)[0-9])|30|31)$    正确格式为：01、09和1、31。
    整数：^-?\d+$
    非负浮点数（正浮点数 + 0）：^\d+(\.\d+)?$
    正浮点数   ^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$
    非正浮点数（负浮点数 + 0） ^((-\d+(\.\d+)?)|(0+(\.0+)?))$
    负浮点数  ^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$
    浮点数  ^(-?\d+)(\.\d+)?
    符号表示意义：
    匹配除换行符以外的任意字符
    \w 	匹配字母或数字或下划线或汉字
    \s 	匹配任意的空白符
    \d 	匹配数字
    \b 	匹配单词的开始或结束
    ^ 	匹配字符串的开始
    $ 	匹配字符串的结束
    [\u4e00-\u9fa5]{2,20} 匹配2-20个汉字

    .　　　　匹配除换行符 \n 之外的任何单字符。要匹配 . ，请使用 \.
    * 	重复零次或更多次
    + 	重复一次或更多次
    ? 	重复零次或一次
    {n} 	重复n次
    {n,} 	重复n次或更多次
    {n,m} 	重复n到m次

    \W 	匹配任意字母，数字，下划线，汉字的字符
    \S 	匹配任意空白符的字符
    \D 	匹配任意数字的字符
    \B 	匹配单词开头或结束的位置
    [^x] 	匹配x以外的任意字符
    [^aeiou] 	匹配aeiou这几个字母以外的任意字符

    (exp) 	匹配exp,并捕获文本到自动命名的组里
    (?<name>exp) 	匹配exp,并捕获文本到名称为name的组里，也可以写成(?'name'exp)
    (?:exp) 	匹配exp,不捕获匹配的文本，也不给此分组分配组号
    零宽断言
    (?=exp) 	匹配exp前面的位置
    (?<=exp) 	匹配exp后面的位置
    (?!exp) 	匹配后面跟的不是exp的位置
    (?<!exp) 	匹配前面不是exp的位置
 */

export default {
  /**
     * 直接量
     */
  int: /^-?\d+$/,

  /**
     * 直接量
     */
  positiveInt: /^\d+$/,

  /**
     * 直接量
     */
  negativeInt: /^-\d+$/,

  /**
     * 直接量
     */
  float: /^-?\d*\.?\d+$/,

  /**
     * 直接量
     */
  positiveFloat: /^\d*\.?\d+$/,

  /**
     * 直接量
     */
  negativeFloat: /^-\d*\.?\d+$/,

  /**
     * 直接量
     */
  phone: /^1[0-9]{2}[0-9]{8}$/,

  /**
     * 直接量
     */
  email: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,

  /**
     * 是否字符 fn()
     * 至少5位字符 fn(5)
     * 固定5位字符 fn(5, 0)
     * 范围0-5位字符 fn(0, 5)
     */
  isVarchar: (m, n) => {
    if (m && n) {
      return new RegExp(`^.{${m}, ${n}}$`, 'g');
    } else if (m && n === undefined) {
      return new RegExp(`.{${m},}`, 'g');
    } else if (m && n === 0) {
      return new RegExp(`^.{${m}}$`, 'g');
    } else {
      return new RegExp(`^.+$`, 'g');
    }
  },

  /**
     * 是否字母 fn()
     * 至少包含5位字母 fn(5)
     * 固定5位字母 fn(5, 0)
     * 范围0-5位字母 fn(0, 5)
     */
  isLetter: (m, n) => {
    if (m && n) {
      return new RegExp(`^[a-zA-Z]{${m}, ${n}}$`, 'g');
    } else if (m && n === undefined) {
      return new RegExp(`[a-zA-Z]{${m},}`, 'g');
    } else if (m && n === 0) {
      return new RegExp(`^[a-zA-Z]{${m}}$`, 'g');
    } else {
      return new RegExp(`^[a-zA-Z]+$`, 'g');
    }
  },

  /**
     * 是否0-9数字 fn()
     * 至少5位0-9数字 fn(5)
     * 固定5位0-9数字 fn(5, 0)
     * 范围0-5位0-9数字 fn(0, 5)
     */
  isNumber: (m, n) =>{
    if (m && n) {
      return new RegExp(`^[0-9]{${m}, ${n}}$`, 'g');
    } else if (m && n === undefined) {
      return new RegExp(`[0-9]{${m},}`, 'g');
    } else if (m && n === 0) {
      return new RegExp(`^[0-9]{${m}}$`, 'g');
    } else {
      return new RegExp(`^[0-9]+$`, 'g');
    }
  },

  /**
     * 是否数字或字母 fn()
     * 至少包含5位数字或字母 fn(5)
     * 固定5位数字或字母 fn(5, 0)
     * 范围0-5位数字或字母 fn(0, 5)
     */
  isLetterOrNumber: (m, n) => {
    if (m && n) {
      return new RegExp(`^[A-Za-z0-9]{${m}, ${n}}$`, 'g');
    } else if (m && n === undefined) {
      return new RegExp(`[A-Za-z0-9]{${m},}`, 'g');
    } else if (m && !n) {
      return new RegExp(`^[A-Za-z0-9]{${m}}$`, 'g');
    } else {
      return new RegExp(`^[A-Za-z0-9]+$`, 'g');
    }
  },

  /**
     * 是否大写 fn()
     * 至少5位大写 fn(5)
     * 固定5位大写 fn(5, 0)
     * 范围0-5范围长度 fn(0, 5)
     */
  isUpperCase: (m, n) => {
    if (m && n) {
      return new RegExp(`^[A-Z]{${m}, ${n}}$`, 'g');
    } else if (m && n === undefined) {
      return new RegExp(`[A-Z]{${m},}`, 'g');
    } else if (m && n === 0) {
      return new RegExp(`^[A-Z]{${m}}$`, 'g');
    } else {
      return new RegExp(`^[A-Z]+$`, 'g');
    }
  },

  /**
     * 是否小写 fn()
     * 至少5位长度 fn(5)
     * 固定5位长度 fn(5, 0)
     * 范围0-5范围长度 fn(0, 5)
     */
  isLowerCase: (m, n) => {
    if (m && n) {
      return new RegExp(`^[a-z]{${m}, ${n}}$`, 'g');
    } else if (m && n === undefined) {
      return new RegExp(`[a-z]{${m},}`, 'g');
    } else if (m && n === 0) {
      return new RegExp(`^[a-z]{${m}}$`, 'g');
    } else {
      return new RegExp(`^[a-z]+$`, 'g');
    }
  },

  /**
     * 是否(指定长度(或m-n)的)正(负)整数
     */
  isInt: (m, n) => {
    if (m && n) {
      return new RegExp(`^-?\d{${m}, ${n}}$`, 'g');
    } else if (m && !n) {
      return new RegExp(`^-?\d{${m}}$`, 'g');
    } else {
      return new RegExp(`^-?\d+$`, 'g');
    }
  },

  /**
     * 是否(指定长度(或m-n)的)正整数
     */
  isPositiveInt: (m, n) => {
    if (m && n) {
      return new RegExp(`^\d{${m}, ${n}}$`, 'g');
    } else if (m && !n) {
      return new RegExp(`^\d{${m}}$`, 'g');
    } else {
      return new RegExp(`^\d+$`, 'g');
    }
  },

  /**
     * 是否(指定长度(或m-n)的)负整数
     */
  isNegativeInt: (m, n) => {
    if (m && n) {
      return new RegExp(`^-\d{${m}, ${n}}$`, 'g');
    } else if (m && !n) {
      return new RegExp(`^-\d{${m}}$`, 'g');
    } else {
      return new RegExp(`^-\d+$`, 'g');
    }
  },

  /**
     * 是否(指定长度(或m-n)的)正(负)浮点数
     */
  isFloat: (m, n) => {
    if (m && n) {
      return new RegExp(`^-?\d*\.?\d{${m}, ${n}}$`, 'g');
    } else if (m && !n) {
      return new RegExp(`^-?\d*\.?\d{${m}}$`, 'g');
    } else {
      return new RegExp(`^-?\d*\.?\d+$`, 'g');
    }
  },

  /**
     * 是否(指定长度(或m-n)的)正浮点数
     */
  isPositiveFloat: (m, n) => {
    if (m && n) {
      return new RegExp(`^\d*\.?\d{${m}, ${n}}$`, 'g');
    } else if (m && !n) {
      return new RegExp(`^\d*\.?\d{${m}}$`, 'g');
    } else {
      return new RegExp(`^\d*\.?\d+$`, 'g');
    }
  },

  /**
     * 是否(指定长度(或m-n)的)负浮点数
     */
  isNegativeFloat: (m, n) => {
    if (m && n) {
      return new RegExp(`^-\d*\.?\d{${m}, ${n}}$`, 'g');
    } else if (m && !n) {
      return new RegExp(`^-\d*\.?\d{${m}}$`, 'g');
    } else {
      return new RegExp(`^-\d*\.?\d+$`, 'g');
    }
  },
};
